import { flexRender as fr, isClassComponent as isc, isExoticComponent as ise, isReactComponent as isr } from '@panwds/react-utils';
/**
 * @deprecated Please use `isExoticComponent` from `@panwds/react-utils`
 */
export const isExoticComponent = ise;
/**
 * @deprecated Please use `isClassComponent` from `@panwds/react-utils`
 */
export const isClassComponent = isc;
/**
 * @deprecated Please use `isReactComponent` from `@panwds/react-utils`
 */
export const isReactComponent = isr;
/**
 * @deprecated Please use `flexRender` from `@panwds/react-utils`
 */
export const flexRender = fr;
//# sourceMappingURL=component.js.map